import React, { FunctionComponent } from 'react'
import { Popover, Select, Typography } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Statuses, TExpert, TStatuses } from '../../../context/types'
import { useAuthContext } from '../../../context/auth'
import './ExpertStatusSelect.css'

const { Paragraph } = Typography
const { Option } = Select

interface ChannelSelectProps {
	onChange: (expert: TExpert, status: keyof TStatuses) => void
	expert: TExpert
}

export const statuses: Record<Statuses, string> = {
	[Statuses.ACTIVE]: 'Active',
	[Statuses.INACTIVE]: 'Inactive',
	[Statuses.ARCHIVED]: 'Archived',
	[Statuses.QUARANTINED]: 'Quarantined By An Admin',
	[Statuses.DISABLED]: 'Disabled By An Admin',
}
const explanationStatuses: Record<Statuses, string> = {
	[Statuses.ACTIVE]: 'Available for members to book calls',
	[Statuses.INACTIVE]: 'Temporarily hide your profile',
	[Statuses.QUARANTINED]: 'Profile is not shown and expert receives notice as to why',
	[Statuses.DISABLED]: 'Profile is archived by admin due to inactivity, conduct or request of expert',
	[Statuses.ARCHIVED]: 'No longer interested in being an expert',
}

const ChannelSelect: FunctionComponent<ChannelSelectProps> = (props) => {
	const { onChange, expert } = props
	const {
		auth: { user },
	} = useAuthContext()
	const isDisabledUserByAdmin = +expert.profile.status < -1 && !user.is_admin
	const handleOnChange = (statusID: keyof TStatuses) => {
		const cloneExpert = JSON.parse(JSON.stringify(expert))
		cloneExpert.profile.status = statusID

		onChange(cloneExpert, statusID)
	}
	const getDisplayOptionStyle = (statusID: string) => {
		if (user.is_admin) {
			return 'block'
		}

		if (statusID === Statuses.QUARANTINED || statusID === Statuses.DISABLED) {
			return 'none'
		}
	}

	return (
		<section className="wrapper">
			<Paragraph className="select-title">Status</Paragraph>
			<Select
				disabled={isDisabledUserByAdmin}
				className="select"
				defaultValue={expert.profile.status}
				onChange={(statusID: keyof TStatuses) => handleOnChange(statusID)}
			>
				{Object.keys(statuses).map((id, i) => (
					<Option style={{ display: getDisplayOptionStyle(id) }} key={i} value={id}>
						<span className="ellipsis" style={{ paddingRight: 5 }}>
							{statuses[id as keyof TStatuses]}
						</span>
						<Popover content={explanationStatuses[id as keyof TStatuses]}>
							<InfoCircleOutlined />
						</Popover>
					</Option>
				))}
			</Select>
		</section>
	)
}

export default ChannelSelect
